import { ShieldCheck } from '@phosphor-icons/react';

export default ShieldCheck;
